import { removeBook } from "../actionCreator";

const deleteBook = (bookId) => {
    return async (dispatch) => {
    await fetch(`http://localhost:9000/books/${bookId}`, {
            method: 'DELETE'
        })

    dispatch(removeBook(bookId))        
    }
}

export default deleteBook;